// IRCTC FORGOT USERNAME ACTIONS
export const ACTION_SET_USER_EMAIL_FORGOT_USERNAME = '@rails/ACTION_SET_USER_EMAIL_FORGOT_USERNAME';
export const ACTION_SET_SELECTED_DATE_FORGOT_USERNAME = '@rails/ACTION_SET_SELECTED_DATE_FORGOT_USERNAME';
export const ACTION_SET_COMPONENT_TO_SHOW_FORGOT_USERNAME = '@rails/ACTION_SET_COMPONENT_TO_SHOW_FORGOT_USERNAME';
export const ACTION_SET_SHOW_ERROR_INPUT_FORM = '@rails/ACTION_SET_SHOW_ERROR_INPUT_FORM';
export const ACTION_SET_SUBMIT_FAILED_ERR_MSG_FORGOT_USERNAME =
  '@rails/ACTION_SET_SUBMIT_FAILED_ERR_MSG_FORGOT_USERNAME';
